import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '../components/atoms/Button';
import IcoHome from '../assets/images/board/ico-home.svg';
import IcoLogout from '../assets/images/board/ico-logout.svg';
import IcoCal from '../assets/images/board/ico-calendar.svg';
import IcoDown from '../assets/images/board/ico-down.svg';
import IcoUp from '../assets/images/board/ico-up.svg';
import Logo from '../assets/images/logo.png';
import IcoAdd from '../assets/images/button/ico-add.svg';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import Table from '../components/atoms/Table';
import Input from '../components/atoms/Input';
import { useAddPostComment, usePostDelete, usePosts, usePostsSubmit, usePostsYearMonth } from '../hooks/RQuery/utils/posts';
import { lastDate, transFormatDate } from '../util/scripts';
import { useRecoilState } from 'recoil';
import { confirmState } from '../store/Atoms';
import useSessionStorage from '../hooks/useSessionStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import useLogInOut from '../hooks/useLogInOut';
import BoardCard, { BoardCardSt } from '../components/templates/BoardCard';

const BoardSt = {
  Contain: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    background: #f7f7f7;
  `,
  Left: styled.div`
    width: 280px;
    height: 100%;
  `,
  LeftInner: styled.div`
    height: calc(100% - 70px);
    padding: 20px 20px 50px;
  `,
  Logo: styled.h1`
    width: 100%;
    height: 110px;
    background: url(${Logo}) no-repeat center;
    background-size: cover;
    margin-bottom: 20px;
    border-radius: 18px;
    box-shadow: 4px 4px 27px 6px #21424e08;
    cursor: pointer;
  `,
  BoardFilter: styled.div`
    background: #fff;
    border-radius: 18px;
    height: calc(100% - 130px);
    box-shadow: 4px 4px 27px 6px #21424e08;
  `,
  Right: styled.div`
    width: calc(100% - 280px);
    height: 100%;
  `,
  RightInner: styled.div`
    height: calc(100% - 69px);
    padding: 49px 20px 20px 30px;
  `,
  Head: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    margin-bottom: 50px;
  `,
  Cont: styled.div`
    height: calc(100% - 52px - 50px);
  `,
  BtnGroup: styled.div`
    display: flex;
    align-items: center;
    button {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
  `,
  UserMenu: styled.div`
    display: flex;
    align-items: center;
    margin-right: 17px;
  `,
  UserBtn: styled.button<{ url: string }>`
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #54666a;
    &:before {
      content: '';
      width: 24px;
      height: 24px;
      background: url(${(p) => (p.url ? p.url : '')}) no-repeat center;
      margin-right: 4px;
    }
    &:not(:last-child) {
      margin-right: 14px;
      &:after {
        content: '';
        width: 1px;
        height: 10px;
        margin-left: 14px;
        background: #aeb7bf;
      }
    }
  `,
  FilterLabel: styled.strong`
    height: 44px;
    display: flex;
    align-items: center;
    padding: 42px 30px 0;
    color: #677179;
    font-size: 16px;
    font-weight: 600;
    &:before {
      content: '';
      width: 24px;
      height: 24px;
      margin-right: 8px;
      background: url(${IcoCal}) no-repeat center;
    }
  `,
  BtnArea: styled.div`
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid #ddd;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    > button {
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  `,
  FilterList: styled.ul`
    height: calc(100% - 86px - 96px);
  `,
  FilterItem: styled.li`
    align-items: center;
    text-indent: 44px;
    cursor: pointer;
    span,
    dt,
    dd {
      position: relative;
      height: 56px;
      display: flex;
      align-items: center;
      color: #54666a;
      font-size: 16px;
      font-weight: 500;
    }
    dt {
      &:after {
        content: '';
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        background: url(${IcoDown}) no-repeat center;
      }
    }
    dd {
      height: 0;
      overflow: hidden;
      text-indent: 56px;
      &.selected {
        background: #f2f8f9;
        color: #091219;
        font-size: 16px;
        font-weight: 600;
        &:after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background: linear-gradient(to bottom, #0077a6, #00bea3);
        }
      }
    }
    &.active {
      span {
        background: #f2f8f9;
        color: #091219;
        font-size: 16px;
        font-weight: 600;
        &:after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background: linear-gradient(to bottom, #0077a6, #00bea3);
        }
      }
      dt {
        &:after {
          background-image: url(${IcoUp});
        }
      }
      dd {
        height: 56px;
      }
    }
  `,
  AddBtnArea: styled.div`
    padding: 20px;
  `,
  TextArea: styled.textarea`
    width: 100%;
    height: 210px;
    padding: 12px 14px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    resize: none;
    color: #192640;
    outline: none;
    margin-top: 16px;
    &:focus {
      border-color: #0a95b4;
    }
    &::placeholder {
      color: #8d97a4;
    }
  `,
};

interface YearMonthFilterProps {
  year: string;
  months: MonthFilterProps[];
  active: boolean;
}

interface MonthFilterProps {
  month: string;
  selected: boolean;
}

interface ListProps {
  category: 'COMMON' | 'HELP';
  dateFrom: string | null;
  dateTo: string | null;
}

const Board = ({ category }) => {
  const memberId = sessionStorage.getItem('memberId')!;
  const navigate = useNavigate();
  const location = useLocation();
  const { onLogInOut } = useLogInOut();
  const [colCount, setColCount] = useState(1);
  const [confirm, setConfirm] = useRecoilState(confirmState);
  const [filterAll, setFilterAll] = useState(true);
  const [isWriteMode, setIsWriteMode] = useState(false);
  const [filter, setFilter] = useState<YearMonthFilterProps[]>([]);
  const [listParam, setListParam] = useState<ListProps>({
    category: category,
    dateFrom: null,
    dateTo: null,
  });
  const [submitData, setSubmitData] = useState({
    memberId: memberId,
    title: '',
    content: '',
    category: category,
  });
  const [postArray, setPostArray] = useState<any>([]);
  //게시글 목록 조회
  const { data: postData, isSuccess } = usePosts(listParam);

  //전체 게시글 생성 년/월 조회
  const { data: yearMonthData, isSuccess: isYearMonthSuccess } = usePostsYearMonth();

  //게시글 작성 api
  const postPosts = usePostsSubmit({ category });

  //게시글 입력
  const onChange = (e) => {
    setSubmitData({ ...submitData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (postData) {
      const newArr: any = [];
      [...postData].reverse().map((i) => {
        newArr.push({ ...i, isCommentView: false });
      });
      setPostArray(newArr);
    }
  }, [postData]);

  const onCommentView = (data) => {
    const newArr = [...postArray];

    newArr.filter((i) => i.postId === data.postId)[0].isCommentView = !newArr.filter((i) => i.postId === data.postId)[0].isCommentView;
    setPostArray(newArr);
  };

  //게시글 등록
  const onSubmit = () => {
    postPosts.mutate(submitData, {
      onSuccess: (data: any) => {
        setConfirm({
          ...confirm,
          text: data.message,
          submitFunc: () => {
            setConfirm({ ...confirm, text: '' });
            setIsWriteMode(false);
            setSubmitData({
              ...submitData,
              title: '',
              content: '',
            });
          },
        });
      },
      onError: (err: any) => {
        setConfirm({
          ...confirm,
          text: err.response.data.message,
          submitFunc: () => {
            setConfirm({ ...confirm, text: '' });
          },
        });
      },
    });
  };

  useEffect(() => {
    const resize = () => {
      const masonryArea = document.getElementsByClassName('masonryArea')[0];
      if (masonryArea.clientWidth >= 1200) {
        setColCount(4);
      } else if (masonryArea.clientWidth >= 800) {
        setColCount(3);
      } else if (masonryArea.clientWidth >= 400) {
        setColCount(2);
      } else {
        setColCount(1);
      }
    };
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  //게시글 등록 모드 변경
  const onModeChange = (bool: boolean) => {
    setIsWriteMode(bool);
  };

  const onClickAll = () => {
    const newArr = [...filter];
    newArr.map((i) => {
      i.months.map((j) => {
        j.selected = false;
      });
    });
    setFilter(newArr);
    setFilterAll(true);
  };
  const onClickYear = (year) => {
    const newArr = [...filter];
    newArr.map((i) => {
      i.active = !i.active ? i.year === year : false;
    });
    setFilter(newArr);
  };

  const onClickMonth = (year, month) => {
    const newArr = [...filter];
    newArr.map((i) => {
      i.months.map((j) => {
        j.selected = i.year === year && j.month === month;
      });
    });
    setFilterAll(false);
    setFilter(newArr);
    setListParam({ ...listParam, dateFrom: transFormatDate(`${year}-${month}-1`, '-'), dateTo: transFormatDate(`${year}-${month}-${lastDate(year, month)}`, '-') });
  };

  const onTabMenu = (str: 'COMMON' | 'HELP') => {
    navigate(str === 'COMMON' ? '/board' : '/help');
    setSubmitData({ ...submitData, category: str });
    setListParam({ ...listParam, category: str });
  };

  useEffect(() => {
    if (yearMonthData) {
      const newArr: YearMonthFilterProps[] = [];
      console.log(yearMonthData);
      yearMonthData.map((i) => {
        const months: MonthFilterProps[] = [];
        i.months?.map((j) => {
          months.push({ month: j, selected: false });
        });
        newArr.push({
          year: i.year,
          months: months,
          active: false,
        });
      });
      setFilter(newArr);
    }
  }, [yearMonthData]);

  useEffect(() => {
    if (filterAll) {
      setListParam({ ...listParam, dateFrom: null, dateTo: null });
    }
  }, [filterAll]);

  return (
    <BoardSt.Contain>
      <BoardSt.Left>
        <BoardSt.LeftInner>
          <BoardSt.Logo onClick={() => navigate('/')}></BoardSt.Logo>
          <BoardSt.BoardFilter>
            <BoardSt.FilterLabel>게시글 등록년월</BoardSt.FilterLabel>
            <BoardSt.FilterList>
              <BoardSt.FilterItem onClick={onClickAll} className={filterAll ? 'active' : ''}>
                <span>전체</span>
              </BoardSt.FilterItem>
              {filter.map((i) => {
                return (
                  <BoardSt.FilterItem className={i.active ? 'active' : ''} key={i.year}>
                    <dl>
                      <dt onClick={() => onClickYear(i.year)}>{i.year}년</dt>
                      {i.months.map((j, index) => {
                        return (
                          <dd onClick={() => onClickMonth(i.year, j.month)} className={j.selected ? 'selected' : ''} key={index}>
                            {j.month}월
                          </dd>
                        );
                      })}
                    </dl>
                  </BoardSt.FilterItem>
                );
              })}
            </BoardSt.FilterList>
            {sessionStorage.getItem('token') && (
              <BoardSt.AddBtnArea>
                <Button text={'게시글 등록'} height={56} $leftIco={IcoAdd} $isGradientBtn={true} onClick={() => setIsWriteMode(true)} />
              </BoardSt.AddBtnArea>
            )}
          </BoardSt.BoardFilter>
        </BoardSt.LeftInner>
      </BoardSt.Left>
      <BoardSt.Right>
        <BoardSt.RightInner>
          <BoardSt.Head>
            {/* 탭 */}
            <BoardSt.BtnGroup>
              <Button text={'HELP'} $isTabButton={true} width={138} height={52} $active={location.pathname.split('/')[1] === 'help'} $isGradientBtn={true} $fontSize={20} onClick={() => onTabMenu('HELP')} />
              <Button text={'게시판'} $isTabButton={true} width={138} height={52} $active={location.pathname.split('/')[1] === 'board'} $isGradientBtn={true} $fontSize={20} onClick={() => onTabMenu('COMMON')} />
            </BoardSt.BtnGroup>
            {/* 사용자 메뉴 */}
            <BoardSt.UserMenu>
              <BoardSt.UserBtn type={'button'} url={IcoHome} onClick={() => navigate('/')}>
                HOME
              </BoardSt.UserBtn>
              <BoardSt.UserBtn type={'button'} url={IcoLogout} onClick={onLogInOut}>
                {!!sessionStorage.getItem('token') ? 'LOGOUT' : 'LOGIN'}
              </BoardSt.UserBtn>
            </BoardSt.UserMenu>
          </BoardSt.Head>
          <BoardSt.Cont className={'cScroll'}>
            {/*게시글 등록 폼*/}
            {isWriteMode && (
              <>
                <div className={'dimmed'} style={{ zIndex: 10, width: '100%', height: '100%', position: 'fixed', left: 0, top: 0, background: 'rgba(0, 0, 0, 0.5)' }}></div>
                <BoardCardSt.Card style={{ position: 'fixed', left: '50%', top: '50%', zIndex: 11, transform: 'translate(-50%,-50%)', width: 420 }}>
                  <BoardCardSt.CardInner>
                    <Input type={'text'} placeholder={'제목을 입력해 주세요.'} width={'100%'} name={'title'} onChange={onChange} value={submitData.title} />
                    <BoardSt.TextArea placeholder={'내용을 입력해 주세요.'} name={'content'} onChange={onChange} value={submitData.content}></BoardSt.TextArea>
                    <BoardSt.BtnArea>
                      <Button text={'취소'} $colorType={'white'} width={98} height={50} onClick={() => setIsWriteMode(false)} />
                      <Button text={'저장'} $colorType={'peacock'} width={98} height={50} onClick={onSubmit} />
                    </BoardSt.BtnArea>
                  </BoardCardSt.CardInner>
                </BoardCardSt.Card>
              </>
            )}
            <Masonry className={'masonryArea'} gutter={'10px'} columnsCount={colCount}>
              {/* 게시글 리스트*/}
              {isSuccess &&
                postArray.map((i: any, index) => {
                  return <BoardCard category={category} postData={i} key={index} onCommentView={onCommentView} />;
                })}
            </Masonry>
          </BoardSt.Cont>
        </BoardSt.RightInner>
      </BoardSt.Right>
    </BoardSt.Contain>
  );
};

export default Board;
